import { forwardRef, useEffect, useRef, useState } from 'react';
import * as Ad from './components';

const AdElement = ({ id = 'ad_bnr_atf_01', className = '', count = null, divisor = 3 }, fwdRef) =>
{
	const adRef = useRef(null);
	const [adUpdateRange, setAdRange] = useState(0);

	useEffect(() => {

		if ((fwdRef.current || adRef.current) && window.AdFuel)
		{
			window.AdFuel.queueRegistry('https://cdn.cnn.com/ads/cnn/cnn_us_leaf_inter.json',
			{
				sync: true,
				syncSlots: [id],
				slots:  [id],
				dispatch: true,
			});
		}
	}, [adRef.current, fwdRef.current]);

  	useEffect(() =>
  	{
  		if (count !== null) {
  			const quotient = Math.floor(count / divisor);
  			if (quotient !== adUpdateRange) {
  				setAdRange(quotient);
  			}
  		}
  	}, [count]);

	useEffect(() =>
  	{
		if (adRef.current)
		{
			if (count !== null && adUpdateRange !== 0)
			{
				window.AdFuel.refresh([id]);		
			}
		}
  	}, [adUpdateRange]);

	useEffect(() => () =>
	{
		window.AdFuel.destroySlots([id]);
	}, []);

	return 	<Ad.Container
				ref={fwdRef || adRef}
				className={className}>
					<Ad.Content id={id} />
			</Ad.Container>
}

export default forwardRef(AdElement);